import api from '../../helpers/api';

export const getSupplierTags = (body) => api.post('supplier-tag/search-suppliers-tags' , {...body})

export const createSupplierTag = (formData) => api.post('supplier-tag' , {...formData})

export const updateSupplierTag = (id , formData) => api.put(`supplier-tag/${id}`, {...formData} )